<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-details details-area">
        <b-form novalidate>
          <!-- NOME E ADDR -->
          <div class="">
            <div class="header-form">
              <h5 v-if="formType == 'edit'" class="form-header">
                Editar {{ oldName }}
              </h5>
              <h5 v-else class="form-header">Adicionar {{ pickedMod.NAME }}</h5>
            </div>
          </div>
          <div class="pl-2 pr-2">
            <div class="col-xs-12">
              <b-form-text> Nome do MTD</b-form-text>
              <b-form-input
                v-model="form.NAME"
                :state="mtdState"
                type="text"
                placeholder="Nome"
                size="sm"
              />
            </div>
            <div class="col-xs-12">
              <b-form-text>UID</b-form-text>
              <div class="container col-xs-12">
                <div class="row">
                  <b-form-input
                    class="col-sm"
                    v-model="form.UID1"
                    placeholder="11111111"
                    aria-describedby="latInputLiveFeedback"
                    maxlength="8"
                    minlength="8"
                    type="text"
                    :state="UID1state"
                    id="UID1"
                    size="sm"
                  />
                  <h5 class="separator">-</h5>
                  <b-form-input
                    class="col-sm"
                    v-model="form.UID2"
                    placeholder="22222222"
                    aria-describedby="latInputLiveFeedback"
                    maxlength="8"
                    minlength="8"
                    type="text"
                    size="sm"
                    :state="UID2state"
                  />
                </div>
              </div>
              <div class="container col-xs-12">
                <div class="row">
                  <b-form-input
                    class="col-sm"
                    v-model="form.UID3"
                    placeholder="33333333"
                    aria-describedby="latInputLiveFeedback"
                    maxlength="8"
                    minlength="8"
                    type="text"
                    :state="UID3state"
                    size="sm"
                  />
                  <h5 class="separator">-</h5>
                  <b-form-input
                    class="col-sm"
                    v-model="form.UID4"
                    placeholder="44444444"
                    aria-describedby="latInputLiveFeedback"
                    maxlength="8"
                    minlength="8"
                    type="text"
                    :state="UID4state"
                    size="sm"
                  />
                </div>
              </div>

              <b-form-invalid-feedback id="latInputLiveFeedback">
                Permitidos apenas números, um único ponto decimal e um único
                hífen indicando valor negativo. UUID não pode ter somente
                caracteres não numéricos.
              </b-form-invalid-feedback>

              <b-form-text>Origem</b-form-text>

              <b-form-input
                v-model="form.ORIGIN"
                placeholder="Origem"
                aria-describedby="lonInputLiveFeedback"
                :state="ORIGINstate"
                type="number"
                :min="0"
                :max="250"
                size="sm"
              />

              <b-form-text>Intervalo de leitura (minutos)</b-form-text>
              <b-form-input
                v-model="form.SLEEP_TIME"
                placeholder="Intervalo de leitura"
                aria-describedby="lonInputLiveFeedback"
                type="number"
                :state="SLEEP_TIMEstate"
                :min="1"
                size="sm"
              />
            </div>

            <div class="col-xs-12">
              <b-form-text>Localização</b-form-text>
              <b-form-input
                v-model="form.LATITUDE"
                placeholder="Latitude"
                aria-describedby="latInputLiveFeedback"
                :state="LATstate"
                maxlength="40"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!LATstate"
                id="latInputLiveFeedback"
              >
                Permitidos apenas números, um único ponto decimal e um único
                hífen indicando valor negativo. Latitudes não podem ter valor
                menor que -90 ou maior que 90 graus.
              </b-form-invalid-feedback>

              <b-form-text v-show="form.LONGITUDE">Longitude</b-form-text>
              <b-form-input
                v-model="form.LONGITUDE"
                placeholder="Longitude"
                aria-describedby="lonInputLiveFeedback"
                :state="LONstate"
                maxlength="40"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!LONstate"
                id="lonInputLiveFeedback"
              >
                Permitidos apenas números, um único ponto decimal e um único
                hífen indicando valor negativo. Longitudes não podem ter valor
                menor que -180 ou maior que 180 graus.
              </b-form-invalid-feedback>
            </div>

            <div class="col-xs-12">
              <div class="group-inputs-title">Equipamentos</div>
              <b-btn
                @click="show.valve = !show.valve"
                v-if="modelSpecification.valve.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Atuadores ({{
                  modelSpecification.valve.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.valve.length }})</b-btn
              >
              <div v-if="show.valve">
                <div
                  v-for="valve in modelSpecification.valve"
                  :key="valve.POSITION"
                  class="row around-xs middle-xs"
                >
                  <b-form-text class="col-xs-12">
                    Saída {{ valve.POSITION }}
                  </b-form-text>
                  <searchable-select
                    class="col-xs-5"
                    v-model="valve.EQUIPMENT"
                    placeholder="Equipamento"
                    :current-value="formType == 'edit' ? valve.CURRENT_EQUIPMENT : null"
                    :current-label="valve.NAME_EQUIPMENT"
                    :groups="[
                      { label: 'Válvulas', items: valves, textField: 'NAME', valueField: 'ID' },
                      { label: 'Bombas', items: pumps, textField: 'NAME', valueField: 'ID' },
                    ]"
                  />
                  <b-form-select
                    size="sm"
                    class="col-xs-5"
                    v-model="valve.OPERATION"
                  >
                    <option :value="2">Abrir e Fechar</option>
                    <option :value="1">Abrir</option>
                    <option :value="0">Fechar</option>
                  </b-form-select>
                </div>
              </div>
              <b-btn
                @click="show.i2c = !show.i2c"
                v-if="modelSpecification.i2c.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Sensores I2C ({{
                  modelSpecification.i2c.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.i2c.length }})</b-btn
              >
              <div v-if="show.i2c">
                <div
                  v-for="i2c in modelSpecification.i2c"
                  :key="i2c.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="i2c.EQUIPMENT"
                    class="col-xs-11"
                    :options="sensorsi2c"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`I2C ${i2c.POSITION}`"
                    :current-value="formType == 'edit' ? i2c.CURRENT_EQUIPMENT : null"
                    :current-label="i2c.NAME_EQUIPMENT"
                  />
                </div>
              </div>
              <b-btn
                @click="show.sdi12 = !show.sdi12"
                v-if="modelSpecification.sdi12.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Sensores SDI-12 ({{
                  modelSpecification.sdi12.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.sdi12.length }})
              </b-btn>
              <div v-if="show.sdi12">
                <div
                  v-for="sdi12 in modelSpecification.sdi12"
                  :key="sdi12.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="sdi12.EQUIPMENT"
                    class="col-xs-11"
                    :options="sensorssdi"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`SDI-12 ${sdi12.POSITION}`"
                    :current-value="
                      formType == 'edit' || (formType == 'duplicate' && sdi12.CURRENT_EQUIPMENT)
                        ? sdi12.CURRENT_EQUIPMENT
                        : null
                    "
                    :current-label="sdi12.NAME_EQUIPMENT"
                  />
                </div>
              </div>

              <b-btn
                @click="show.digital = !show.digital"
                v-if="modelSpecification.digital.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Hidrômetros/Sensores de pulso ({{
                  modelSpecification.digital.filter((e) => !!e.EQUIPMENT)
                    .length
                }}/{{ modelSpecification.digital.length }})</b-btn
              >
              <div v-if="show.digital">
                <div
                  v-for="digital in modelSpecification.digital"
                  :key="digital.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="digital.EQUIPMENT"
                    class="col-xs-11"
                    :placeholder="`Hidrômetro/Sensor de Pulso ${digital.POSITION}`"
                    :current-value="formType == 'edit' ? digital.CURRENT_EQUIPMENT : null"
                    :current-label="digital.NAME_EQUIPMENT"
                    :groups="[
                      { label: 'Hidrômetros', items: hydros, textField: 'NAME', valueField: 'ID', prefix: 'h' },
                      { label: 'Sensores de pulso', items: pulses, textField: 'NAME', valueField: 'ID', prefix: 'p' },
                    ]"
                  />
                </div>
              </div>
            </div>

            <div class="col-xs-12">
              <b-btn
                @click="show.onoff = !show.onoff"
                v-if="modelSpecification.onoff.length"
                block
                size="sm"
                rounded
                variant="orange"
                >Sensores ON/OFF ({{
                  modelSpecification.onoff.filter((e) => !!e.EQUIPMENT).length
                }}/{{ modelSpecification.onoff.length }})</b-btn
              >
              <div v-if="show.onoff">
                <div
                  v-for="onoff in modelSpecification.onoff"
                  :key="onoff.POSITION"
                  class="row around-xs middle-xs"
                >
                  <searchable-select
                    v-model="onoff.EQUIPMENT"
                    class="col-xs-11"
                    :options="onoffs"
                    text-field="NAME"
                    value-field="ID"
                    :placeholder="`Sensores On/Off ${onoff.POSITION}`"
                    :current-value="formType == 'edit' ? onoff.CURRENT_EQUIPMENT : null"
                    :current-label="onoff.NAME_EQUIPMENT"
                  />
                </div>
              </div>
            </div>

            <!-- <div class="col-xs-12">
                      <b-btn
            @click="show.sdi12 = !show.sdi12"
            v-if="modelSpecification.sdi12.length"
            block
            size="sm"
            squared
            variant="orange"
            >Sensores SDI-12 ({{
              modelSpecification.sdi12.filter((e) => !!e.EQUIPMENT).length
            }}/{{ modelSpecification.sdi12.length }})</b-btn
          >
          <div v-if="show.sdi12">
            <div
              v-for="(sdi12, index) in modelSpecification.sdi12"
              :key="sdi12.POSITION"
              class="row around-xs middle-xs"
            >
              <b-form-select
                size="sm"
                v-model="sdi12.EQUIPMENT"
                class="col-xs-11"
              >
                <template slot="first">
                  <option :value="null">SDI-12 {{ index }}</option>
                  <option
                    v-if="formType == 'edit' && sdi12.CURRENT_EQUIPMENT"
                    :value="sdi12.CURRENT_EQUIPMENT"
                  >
                    {{ sdi12.NAME_EQUIPMENT }} (atual)
                  </option>
                </template>
                <option v-for="sdi in sensorssdi" :key="sdi.ID" :value="sdi.ID">
                  {{ sdi.NAME }}
                </option>
              </b-form-select>
            </div>
          </div>
          </div> -->
            <!-- OBSERVAÇÕES -->
            <div class="col-xs-12">
              <div class="group-inputs-title">Extra:</div>
              <b-form-text>Observações</b-form-text>
              <!-- <b-form-text v-show="form.NOTE">Observações</b-form-text> -->
              <b-form-input
                v-model="form.NOTE"
                placeholder="Observações"
                aria-describedby="lonInputLiveFeedback"
                type="text"
                maxLength="120"
                size="sm"
              >
              </b-form-input>
            </div>
          </div>
          <!--ID, origem, stand by -->
        </b-form>
      </div>
      <footer id="footer">
        <b-btn
          size="sm"
          variant="outline-secondary"
          @click="$emit('close-form')"
          class="mr-1 ml-2"
        >
          Fechar
        </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm"> Salvar </b-btn>
      </footer>
    </div>
    <b-modal
      ref="formError"
      no-close-on-backdrop
      centered
      hide-footer
      body-bg-variant="light"
      title="Atenção!"
    >
      <div class="modal-form row pb-3">
        <div class="col-xs-12 center-xs">
          <alert-icon title="" style="font-size: 3em; color: #ffc107" />
        </div>
        <div class="col-xs-12 error-title">
          Não é possível salvar os dados do formulário porque
        </div>
        <div class="col-xs-12 error-description">
          <ul>
            <li v-for="err in errors" :key="err">{{ err }}</li>
          </ul>
        </div>
      </div>
      <b-btn
        v-if="$refs.formError"
        block
        variant="secondary"
        size="sm"
        @click="$refs.formError.hide"
        >Irei corrigir</b-btn
      >
    </b-modal>
  </div>
</template>

<script>
import {
  checkLAT,
  checkLON,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
export default {
  name: "mtd-form",
  components: {
    SearchableSelect,
  },
  props: {
    showForm: Boolean,
    formType: String,
    equipment: String,
    models: Array,
    pickedMod: Object,
    alreadyUsedName: [String, Array],
    alreadyUsedUid: Array,
    oldName: [Boolean, String],
    itemToEdit: [Boolean, Number, Object],
    emrsensors: Array,
    pirsensors: Array,
    valves: Array,
    pumps: Array,
    modbusPumps: Array,
    hydros: Array,
    pulses: Array,
    sensors: Array,
    onoffs: Array,
    modbusSensors: Array,
    sensorsi2c: Array,
    sensorssdi: Array,
  },
  data() {
    return {
      errors: [],
      step: 1,
      regexMTD: null,
      regexHex: null,
      form: {
        MODEL_NAME: null,
        NAME: null,
        LATITUDE: null,
        LONGITUDE: null,
        SLEEP_TIME: 0,
        ORIGIN: null,
        UID1: null,
        UID2: null,
        UID3: null,
        UID4: null,
        D1: null,
        D2: null,
        D3: null,
        D4: null,
        O1: null,
        O1F: null,
        O2: null,
        O2F: null,
        O3: null,
        O3F: null,
        O4: null,
        O4F: null,
        P1: null,
        P2: null,
        P3: null,
        P4: null,
        L1: null,
        L2: null,
        L3: null,
        L4: null,
        I2C: null,
        I2C1: null,
        I2C2: null,
        I2C3: null,
        I2C4: null,
        SDI12: null, //REMOVER
        SDI12I1: null,
        SDI12I2: null,
        SDI12I3: null,
        SDI12I4: null,
        FK_MODEL: null,
        NOTE: null,
      },
      pickedModel: {},
      modelSpecification: {
        hydro: [],
        digital: [],
        valve: [],
        pulse: [],
        onoff: [],
        i2c: [],
        sdi12: [],
      },
      show: {
        hydro: false,
        digital: false,
        valve: false,
        pulse: false,
        i2c: false,
        sdi12: false,
        onoff: false,
      },
      repetitions: [],
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.show = {
          emr: false,
          // s_modbus: false,
          // p_modbus: false,
          valve: false,
          hydro: false,
          digital: false,
          // sensor: false,
          onoff: false,
          pulse: false,
          i2c: false,
          sdi12: false,
        };
        if (this.formType == "add") this.resetForm();
        // Edit
        else {
          this.form.ID = this.itemToEdit.ID;
          this.form.LATITUDE = this.itemToEdit.LATITUDE;
          this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
          this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
          this.form.MODEL_NAME = this.itemToEdit.MODEL_NAME;
          this.form.NAME = this.itemToEdit.NAME;
          this.form.ORIGIN = Number(this.itemToEdit.ORIGIN);
          this.form.UID1 = this.itemToEdit.UID.split("-")[0];
          this.form.UID2 = this.itemToEdit.UID.split("-")[1];
          this.form.UID3 = this.itemToEdit.UID.split("-")[2];
          this.form.UID4 = this.itemToEdit.UID.split("-")[3];
          this.form.SLEEP_TIME = Number(this.itemToEdit.SLEEP_TIME);
          this.modelSpecification = {
            valve: this.itemToEdit.VALVE,
            hydro: this.itemToEdit.HYDRO,
            digital: this.joinDigitalInput(),
            onoff: this.itemToEdit.ONOFF,
            pulse: this.itemToEdit.PULSE,
            i2c: this.itemToEdit.I2C,
            sdi12: this.itemToEdit.SDI12,
          };
          this.form.NOTE = this.itemToEdit.NOTE;
        }
      }
    },
  },
  computed: {
    nameState() {
      return testName(this.form.MODEL_NAME);
    },
    LATstate() {
      let LAT = String(Number(this.form.LATITUDE));
      return checkLAT(LAT);
    },
    LONstate() {
      let LON = String(Number(this.form.LONGITUDE));
      return checkLON(LON);
    },
    mtdState() {
      let mtd = this.form.NAME;
      let valid = !!mtd;
      let exist = this.alreadyUsedName.includes(mtd);
      if (this.formType == "edit" || this.formType == "duplicate") {
        let currently = mtd == this.oldName;
        return valid && (currently || !exist);
      } else {
        return valid && !exist;
      }
    },
    ORIGINstate() {
      let mtd = this.form.ORIGIN;
      let valid = !!mtd && this.form.ORIGIN >= 0;
      // let exist = this.alreadyUsedAddrs.includes(addr);
      if (this.formType == "edit" || this.formType == "duplicate") {
        // let currently = mtd == this.oldAddr;
        return true;
      } else {
        return valid && mtd < 251;
      }
    },
    SLEEP_TIMEstate() {
      let mtd = Number(this.form.SLEEP_TIME);
      let valid = !!mtd;
      // let exist = this.alreadyUsedAddrs.includes(addr);
      if (this.formType == "edit" || this.formType == "duplicate") {
        // let currently = mtd == this.oldAddr;
        return true;
      } else {
        return valid;
      }
    },
    UID1state() {
      let mtd = String(this.form.UID1);
      let length = this.form.UID1 && this.form.UID1.length;
      let valid = !!mtd;
      let isHexa = this.regexHex.test(mtd);
      // let exist = this.alreadyUsedAddrs.includes(addr);
      if (this.formType == "edit" || this.formType == "duplicate") {
        // let currently = mtd == this.oldAddr;
        return true;
      } else {
        return valid && isHexa;
      }
    },
    UID2state() {
      let mtd = String(this.form.UID2);
      let length = this.form.UID2 && this.form.UID2.length;
      let isHexa = this.regexHex.test(mtd);
      let valid = !!mtd;
      // let exist = this.alreadyUsedAddrs.includes(addr);
      if (this.formType == "edit" || this.formType == "duplicate") {
        // let currently = mtd == this.oldAddr;
        return true;
      } else {
        return valid && isHexa;
      }
    },
    UID3state() {
      let mtd = String(this.form.UID3);
      let length = this.form.UID3 && this.form.UID3.length;
      let isHexa = this.regexHex.test(mtd);
      let valid = !!mtd;
      if (this.formType == "edit" || this.formType == "duplicate") {
        return true;
      } else {
        return valid && isHexa;
      }
    },
    UID4state() {
      let mtd = String(this.form.UID4);
      let length = this.form.UID4 && this.form.UID4.length;
      let isHexa = this.regexHex.test(mtd);
      let valid = !!mtd;
      if (this.formType == "edit" || this.formType == "duplicate") {
        return true;
      } else {
        return valid && isHexa;
      }
    },
    NOTEstate() {
      let mtd = String(this.form.NOTE);
      let length = this.form.NOTE;
      let valid = !!mtd;
      if (this.formType == "edit" || this.formType == "duplicate") {
        return true;
      } else {
        return valid;
      }
    },
  },
  created() {
    this.regexMTD = new RegExp("MTD");
    this.regexHex = new RegExp("[0-9a-fA-F]{8}");

    if (this.formType === "add") {
      this.makeModelSpecificationObj(
        "digital",
        this.pickedMod.IN_DIGITAL,
        "dig"
      );
      this.makeModelSpecificationObj("i2c", this.pickedMod.IN_I2C, "i2c");
      this.makeModelSpecificationObj("sdi12", this.pickedMod.IN_SDI12, "sdi12");
      this.makeModelSpecificationObj("onoff", 4, "onoff");
      this.makeModelSpecificationObj("valve", this.pickedMod.OUT, "out");
    } else {
      this.form.ID = this.itemToEdit.ID;
      this.form.LATITUDE = this.itemToEdit.LATITUDE;
      this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
      this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
      this.form.MODEL_NAME = this.itemToEdit.MODEL_NAME;
      this.form.NAME = this.itemToEdit.NAME;
      this.form.ORIGIN = this.itemToEdit.ORIGIN;
      this.form.UID1 = this.itemToEdit.UID.split("-")[0];
      this.form.UID2 = this.itemToEdit.UID.split("-")[1];
      this.form.UID3 = this.itemToEdit.UID.split("-")[2];
      this.form.UID4 = this.itemToEdit.UID.split("-")[3];
      this.form.SLEEP_TIME = this.itemToEdit.SLEEP_TIME;
      this.modelSpecification = {
        hydro: this.itemToEdit.HYDRO,
        valve: this.itemToEdit.VALVE,
        digital: this.joinDigitalInput(),
        pulse: this.itemToEdit.PULSE,
        onoff: this.itemToEdit.ONOFF,
        i2c: this.itemToEdit.I2C,
        sdi12: this.itemToEdit.SDI12,
      };
      this.form.NOTE = this.itemToEdit.NOTE;
    }
  },
  methods: {
    resetForm() {
      this.form = {
        MODEL_NAME: null,
        NAME: null,
        LATITUDE: null,
        LONGITUDE: null,
        SLEEP_TIME: 0,
        NOTE: null,
        ORIGIN: null,
        UID1: null,
        UID2: null,
        UID3: null,
        UID4: null,
        O1: null,
        O1F: null,
        O2: null,
        O2F: null,
        O3: null,
        O3F: null,
        O4: null,
        O4F: null,
        D1: null,
        D2: null,
        D3: null,
        D4: null,
        P1: null,
        P2: null,
        P3: null,
        P4: null,
        L1: null,
        L2: null,
        L3: null,
        L4: null,
        I2C: null, // Remover
        I2C1: null,
        I2C2: null,
        I2C3: null,
        I2C4: null,
        SDI12: null, // Remover
        SDI12I1: null,
        SDI12I2: null,
        SDI12I3: null,
        SDI12I4: null,
        FK_MODEL: null,
      };
      this.modelSpecification = {
        hydro: [],
        digital: [],
        valve: [],
        onoff: [],
        pulse: [],
        i2c: [],
        sdi12: [],
      };
    },
    pickModel(model) {
      // monta a quantidade de campos
      this.pickedModel = model;
      this.makeModelSpecificationObj("s_modbus", 8, "mb");
      this.makeModelSpecificationObj("p_modbus", 8, "mb");
      this.makeModelSpecificationObj("onoff", 4, "onoff");
      this.makeModelSpecificationObj("valve", model.OUT, "out");
      this.makeModelSpecificationObj("digital", model.IN_DIGITAL, "dig");
      this.makeModelSpecificationObj("sensor", model.IN_ANALOGIC, "an");
      this.makeModelSpecificationObj("i2c", model.IN_I2C, "i2c");
      this.makeModelSpecificationObj("sdi12", model.IN_SDI12, "sdi12");
    },
    makeModelSpecificationObj(elem, len, type) {
      let list = this.modelSpecification[elem];

      let value = {};
      if (type === "sdi12") {
        let lenSDI12 = len == 1 ? 2 : len;
        for (let i = 0; i < lenSDI12; i++) {
          value = {
            EQUIPMENT: null,
            POSITION: i + 1,
          };
          list.push(value);
          if (list.length == len) this.modelSpecification[elem] = list;
        }
        return;
      }

      for (let i = 0; i < len; i++) {
        if (type == "out") {
          if (i < 8) {
            if (i % 2 == 0)
              value = {
                EQUIPMENT: null,
                POSITION: i + 1,
                OPERATION: 1,
              };
            else
              value = {
                EQUIPMENT: null,
                POSITION: i + 1,
                OPERATION: 0,
              };
          } else
            value = {
              EQUIPMENT: null,
              POSITION: i + 1,
              OPERATION: 2,
            };
        } else
          value = {
            EQUIPMENT: null,
            POSITION: i + 1,
          };
        list.push(value);
        if (list.length == len) this.modelSpecification[elem] = list;
      }
    },
    putInputValuesInObjToSubmit(elem, name) {
      let list = this.modelSpecification[elem];
      for (let i = 0; i < list.length; i++) {
        if (list[i]) {
          if (name == "D" || name == "P") {
            if (name == "D") {
              //garantir que não há um sensor de pulso e um hidrômetro cadastrado na mesma entrada
              this.form[name + list[i].POSITION] = Number(
                list[i].EQUIPMENT.slice(1)
              );
              this.form["P" + list[i].POSITION] = null;
            } else {
              this.form[name + list[i].POSITION] = Number(
                list[i].EQUIPMENT.slice(1)
              );
              this.form["D" + list[i].POSITION] = null;
            }
          } else if (name == "SDI12")
            list[i].POSITION == 1
              ? (this.form[name + "I" + list[i].POSITION] = list[i].EQUIPMENT)
              : (this.form[name + "I" + Number(list[i].POSITION)] =
                  list[i].EQUIPMENT);
          else if (name == "I2C") {
            /*list[i].POSITION == 1
            ? (this.form[name + list[i].POSITION] = list[i].EQUIPMENT)
            : (this.form[name + (Number(list[i].POSITION)-1)] =
                list[i].EQUIPMENT);*/
            if (list[i].POSITION === 1) {
              let key = `${name + list[i].POSITION}`;
              this.form[key] = list[i].EQUIPMENT;
            } else {
              let key = `${name + list[i].POSITION - 1}`;
              this.form[key] = list[i].EQUIPMENT;
            }
          } else {
            this.form[name + list[i].POSITION] = list[i].EQUIPMENT;
            if (name == "O")
              this.form[name + list[i].POSITION + "F"] = list[i].OPERATION;
          }
        }
      }
    },
    joinDigitalInput() {
      let sel = this.itemToEdit;
      let len = this.itemToEdit.DIGITAL_CAPACITY;
      let digital = [];
      for (let i = 0; i < len; i++) {
        if (sel.HYDRO[i].EQUIPMENT) digital.push(sel.HYDRO[i]);
        else if (sel.PULSE[i].EQUIPMENT) digital.push(sel.PULSE[i]);
        else
          digital.push({
            EQUIPMENT: null,
            POSITION: i + 1,
          });
      }
      return digital;
    },
    separateDigitalInput() {
      this.modelSpecification.hydro = this.modelSpecification.digital.filter(
        (e) => {
          if (e.EQUIPMENT && e.EQUIPMENT[0] == "h") return e;
        }
      );
      this.modelSpecification.pulse = this.modelSpecification.digital.filter(
        (e) => {
          if (e.EQUIPMENT && e.EQUIPMENT[0] == "p") return e;
        }
      );
      this.putInputValuesInObjToSubmit("hydro", "D");
      this.putInputValuesInObjToSubmit("pulse", "P");
    },
    validateNoRepeated(obj, key) {
      let array = this.modelSpecification[key]
        .map((e) => e.EQUIPMENT)
        .filter((e) => !!e);
      if (array.length) {
        let length = array.length;
        return (
          array.filter((e, i, arr) => arr.indexOf(e) == i).length == length
        ); // todos os campos não nulos são diferentes
      } else return true; // não há cadastro nesses campos então é válido
    },
    validateNoRepeatedEquipments(modelSpecif) {
      let ok = [];
      let fail = [];
      // let keys = [
      //   "sensor",
      //   "hydro",
      //   "pulse",
      //   "i2c",
      //   "sdi12"
      // ];
      // let names = [
      //   "sensores analógicos",
      //   "hidrômetros (digital)",
      //   "sensores de pulso (digital)",
      //   "sensores i2c",
      //   "sensores sdi12"
      // ];
      let keys = ["hydro", "pulse", "onoff", "i2c", "sdi12"];
      let names = [
        "hidrômetros (digital)",
        "sensores de pulso (digital)",
        "sensores on/off",
        "sensores i2c",
        "sensores sdi12",
      ];
      for (let idx in keys) {
        if (this.validateNoRepeated(modelSpecif, keys[idx]))
          ok.push(names[idx]);
        else fail.push(names[idx]);
        if (ok.length + fail.length == keys.length)
          if (fail.length) {
            alert(`Há equipamentos repetidos em ${fail}.`, "w");
            this.repetitions = fail;
            return false;
          } else return true;
      }
    },
    checkForm() {
      this.errors = [];
      let obj = {};

      let erros = [
        "É necessário informar um UID que não esteja já sendo usado em outro dispositivo MTD.",
        "A identificação do dispositivo é obrigatória. Valores permitidos: 1 a 250. Não é possível cadastrar um número já existente.",
        "Latitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Latitudes não podem ter valor menor que -90 ou maior que 90 graus.",
        "Longitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Longitudes não podem ter valor menor que -180 ou maior que 180 graus.",
        "Origem é obrigatório",
        "Insira um intervalo de leitura",
        "Primeiro campo UID é obrigatório",
        "Segundo campo UID é obrigatório",
        "Terceiro campo UID é obrigatório",
        "Quarto campo UID é obrigatório",
        `Há equipamentos repetidos em ${this.repetitions}.`,
      ];

      const UID =
        `${this.form.UID1}-${this.form.UID2}-${this.form.UID3}-${this.form.UID4}`.toUpperCase();

      const hasUIDRepeated = this.alreadyUsedUid.includes(UID);
      const UIDState = !hasUIDRepeated;

      const states = [
        UIDState,
        this.mtdState,
        this.LATstate,
        this.LONstate,
        this.ORIGINstate,
        this.SLEEP_TIMEstate,
        this.UID1state,
        this.UID2state,
        this.UID3state,
        this.UID4state,
        // this.NOTEstate,
        this.validateNoRepeatedEquipments(this.modelSpecification),
      ];

      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.separateDigitalInput();
        this.putInputValuesInObjToSubmit("valve", "O");
        this.putInputValuesInObjToSubmit("i2c", "I2C");
        this.putInputValuesInObjToSubmit("sdi12", "SDI12");
        this.putInputValuesInObjToSubmit("onoff", "L");
        if (this.formType == "add") {
          this.form.FK_MODEL = this.pickedMod.ID;

          const { O1, O1F, O2, O2F, O3, O3F, O4, O4F } = this.form;

          obj = {
            NAME: this.form.NAME.toUpperCase(),
            LATITUDE: this.form.LATITUDE,
            LONGITUDE: this.form.LONGITUDE,
            NOTE: this.form.NOTE,
            UID,
            ORIGIN: this.form.ORIGIN,
            SLEEP_TIME: this.form.SLEEP_TIME,
            FK_MODEL: this.form.FK_MODEL,
            O1,
            O1F,
            O2,
            O2F,
            O3,
            O3F,
            O4,
            O4F,
            D1: this.form.D1,
            D2: this.form.D2,
            D3: this.form.D3,
            D4: this.form.D4,
            P1: this.form.P1,
            P2: this.form.P2,
            P3: this.form.P3,
            P4: this.form.P4,
            I2C: null,
            I2C1: this.form.I2C1,
            I2C2: this.form.I2C2,
            I2C3: this.form.I2C3,
            I2C4: this.form.I2C4,
            L1: this.form.L1,
            L2: this.form.L2,
            L3: this.form.L3,
            L4: this.form.L4,
            SDI12: null, // Remover
            SDI12I1: this.form.SDI12I1,
            SDI12I2: this.form.SDI12I2,
            SDI12I3: this.form.SDI12I3,
            SDI12I4: this.form.SDI12I4,
          };

          // this.form.MODEL_NAME = this.pickedMod.NAME;
        }
        this.form.LATITUDE = !!this.form.LATITUDE
          ? parseFloat(this.form.LATITUDE)
          : null;
        this.form.ORIGIN =
          this.form.ORIGIN !== null ? parseInt(this.form.ORIGIN) : null;
        this.form.SLEEP_TIME = !!this.form.SLEEP_TIME
          ? parseInt(this.form.SLEEP_TIME)
          : 0;
        this.form.LONGITUDE = !!this.form.LONGITUDE
          ? parseFloat(this.form.LONGITUDE)
          : null;
        if (this.formType == "edit") {
          const { O1, O1F, O2, O2F, O3, O3F, O4, O4F } = this.form;

          obj = {
            ID: this.itemToEdit.ID,
            NAME: this.form.NAME.toUpperCase(),
            LATITUDE: this.form.LATITUDE,
            LONGITUDE: this.form.LONGITUDE,
            NOTE: this.form.NOTE,
            UID,
            ORIGIN: this.form.ORIGIN,
            SLEEP_TIME: this.form.SLEEP_TIME,
            FK_MODEL: this.form.FK_MODEL,
            O1,
            O1F,
            O2,
            O2F,
            O3,
            O3F,
            O4,
            O4F,
            D1: this.form.D1,
            D2: this.form.D2,
            D3: this.form.D3,
            D4: this.form.D4,
            P1: this.form.P1,
            P2: this.form.P2,
            P3: this.form.P3,
            P4: this.form.P4,
            L1: this.form.L1,
            L2: this.form.L2,
            L3: this.form.L3,
            L4: this.form.L4,
            I2C1: this.form.I2C1,
            I2C2: this.form.I2C2,
            I2C3: this.form.I2C3,
            I2C4: this.form.I2C4,
            SDI12: null, // Remover
            SDI12I1: this.form.SDI12I1,
            SDI12I2: this.form.SDI12I2,
            SDI12I3: this.form.SDI12I3,
            SDI12I4: this.form.SDI12I4,
          };
        }
        if (this.form.FK_MODEL) {
          return this.checkOperation(this.form).then((ret) => {
            this.$emit("submitMTD", obj, this.formType);
            this.resetForm();
            this.$emit("close-form");
          });
        }
      }
    },
    checkOperation(form) {
      return new Promise((resolve) => {
        resolve(form);
      });
    },
  },
};
</script>

<style scoped>
.btn {
  margin-bottom: 5px;
}
.separator {
  margin: 0 5px;
}
@media screen and (max-width: 768px) {
  .container-details {
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0.5em;
    margin-right: 0;
  }
}
</style>
